function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router";
import MessageBus from "./vanilla/messaging/MessageBus";
import { CommercePlatformContext } from "./CommercePlatformContext";
/**
 * This component watches for react-router url changes that
 * and sends them to Commerce Platform via the message bus
 * so that the browser url bar reflects with the url state
 * of your react application inside of the iframe.
 *
 * Usage:
 *   <CommercePlatform >
 *     <Router>
 *       <CommercePlatformUrl>
 *         <Route />
 *         <Route />
 *       </CommercePlatformUrl>
 *     </Router>
 *   </CommercePlatform>
 *
 * Please note that this does handle the opposite direction
 * when, for example, a new url is typed in the url bar by
 * a user.
 *
 * For that functionality please see the initialRoute value
 * provided by the CommercePlatform component.
 */

var CommercePlatformUrlWithoutRouter = function (_Component) {
  _inherits(CommercePlatformUrlWithoutRouter, _Component);

  function CommercePlatformUrlWithoutRouter(props) {
    _classCallCheck(this, CommercePlatformUrlWithoutRouter);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.messageBus = new MessageBus();
    return _this;
  }

  CommercePlatformUrlWithoutRouter.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.props.history.listen(function (toLocation, action) {
      _this2.messageBus.send("appStateChange", {
        path: toLocation.pathname,
        search: toLocation.search
      });
    });
  };

  CommercePlatformUrlWithoutRouter.prototype.render = function render() {
    var _this3 = this;

    return React.createElement(
      CommercePlatformContext.Consumer,
      null,
      function (commercePlatform) {
        return React.createElement(
          Fragment,
          null,
          _this3.props.children
        );
      }
    );
  };

  return CommercePlatformUrlWithoutRouter;
}(Component);

export var CommercePlatformUrl = withRouter(CommercePlatformUrlWithoutRouter);